<template>
  <div class="container-padding">
    <div class="school-address">
      <h3 class="school-address__title">Адрес мастер-классов</h3>
      <div class="school-address__content">
        <MapComponent :address="address" />
        <div class="school-address__info">
          <span class="school-address__info-title">Сеть магазинов Baby Market</span>
          <ContactsComponent />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MapComponent from "components/MapComponent.vue";
import ContactsComponent from "components/ContactsComponent.vue";

export default {
  name: "SchoolAddressComponent",
  computed: {
    address() {
      if (
        this.$store.state.marketplace?.communications &&
        this.$store.state.marketplace.communications.length
      ) {
        return this.$store.state.marketplace.communications.find(
          (item) => item.type.code === this.$store.state._types.ADDRESS
        )?.value;
      }
      return undefined;
    },
  },
  components: {
    ContactsComponent,
    MapComponent,
  },
};
</script>

<style lang="stylus">
.school-address {
  background: var(--gray_o3)
  border-radius: var(--main_radius)
  padding: 50px
  +below(920px) {
    padding: 20px
  }
  +below(480px) {
    padding 0
    background transparent
  }

  &__content {
    display: grid;
    grid-template-columns: 7fr 5fr
    grid-gap: 30px;
    +below(860px) {
      grid-template-columns: 1fr
    }

    .map {
      border-radius: var(--main_radius)
      overflow: hidden;
    }
  }

  &__info {
    &-list {
      display: flex
      flex-direction: column
      gap: 10px
    }

    &-title {
      display: flex;
      font-weight: 700;
      font-size: 1.5em
      line-height: 115%
      margin-bottom: 30px;
    }
  }

  &__address {
    margin-bottom: 30px
  }
}
</style>
